import { PermissionAcl } from '@enums/permission-acl.enum';

export interface PermissionAttributeJson {
  permit: boolean;
  product: string;
  module: string;
  name: string;
}

export class PermissionAttribute {
  constructor(
    public permit?: boolean,
    public acl?: PermissionAcl
  ) {}

  static fromJson(json: Partial<PermissionAttributeJson>): PermissionAttribute {
    return new PermissionAttribute(json.permit, `${json.product}.${json.module}.${json.name}` as PermissionAcl);
  }
}
